<template>
  <div id="risco-cardiovascular" class="row">
    <div class="col-md-12">
      <SelectsV2
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="true"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
      />
    </div>
    <div class="col-md-12">
      <b-tabs fill class="esus-feedback-tabs">
        <b-tab title="Lista" active>
          <template v-slot:title> <i class="icofont-list"></i> Lista </template>
          <div class="row">
            <div class="full-table">
              <div class="col-md-12">
                <div class="info-table">
                  <div class="info-table-item">
                    <Subtitle
                      :reset="nivelSelecionado"
                      @onChangeCheckbox="handleFilterChange"
                    ></Subtitle>
                  </div>
                  <div class="info-table-item">
                    <download-files
                      :callback-pdf="generatePdf"
                      :data="displayedCadastros"
                      :fields="dataFields"
                      name="risco-cardiovascular"
                    >
                    </download-files>
                  </div>
                </div>
                <tabela-cadastros
                  ref="table"
                  :cadastros="displayedCadastros"
                  :loading="loadingLista"
                  @filterSearch="filterSearch($event)"
                ></tabela-cadastros>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import Subtitle from './Subtitle'
import VueApexCharts from 'vue-apexcharts'
import * as Functions from './functions'
import TabelaCadastros from './TabelaCadastros.vue'
import { chartOptions, dataFields, infoHtml } from './utils.js'
import utils from '@/mixins/utils.js'
import TitleTag from '@/components/TitleTag.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import SelectsV2 from '@/components/utils/SelectsV2.vue'

export default {
  name: 'RiscoCardiovascularPorEquipeAcs',
  components: {
    Subtitle,
    Loader,
    apexchart: VueApexCharts,
    TitleTag,
    DownloadFiles,
    TabelaCadastros,
    SelectsV2,
  },
  mixins: [utils],
  data() {
    return {
      equipe: '',
      micro_areas: [],
      micro_area: '',
      cadastros: [],
      loadingLista: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      dataFields: {
        ...dataFields,
      },
      cadastrosOriginais: [],
      nivelSelecionado: null,
      text: infoHtml,
      filterSearchTable: false,
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    async filtros(selectedCheckbox) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais

      // Filtra os dados com base no checkbox selecionado
      if (selectedCheckbox) {
        data = await Functions.exibirItensComNivel(data, selectedCheckbox)
      }

      this.cadastros = data
    },

    handleFilterChange(selectedCheckbox) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.nivelSelecionado = selectedCheckbox
      this.filtros(this.nivelSelecionado)
    },

    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.nivelSelecionado = null
      this.equipe = event
      this.cadastrosOriginais = []
      this.cadastros = []
      if (event != null) {
        this.buscarCadastrosIndividuaisTodosPorEquipe()
      } else {
        this.micro_area = ''
        this.micro_areas = []
        this.cadastros = []
        this.cadastrosOriginais = []
        this.equipe = ''
        return
      }
    },

    async onChangeMicroArea(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      this.nivelSelecionado = null
      if (event !== null) {
        this.loadingLista = true
        this.micro_area = event?.micro_area
        let response = await Functions.getCadastrosIndividuaisPorMicroArea(
          this.$store.state.cod_ibge,
          this.equipe.ine_esf_eap,
          this.micro_area
        )
        if (response) {
          this.cadastros = response
          this.cadastrosOriginais = response
          this.filtros(this.nivelSelecionado)
          this.loadingLista = false
        }
      } else {
        this.cadastrosOriginais = []
        this.cadastros = []
        this.micro_area = ''
        this.onChangeEquipe(this.equipe)
      }
    },

    async buscarCadastrosIndividuaisTodosPorEquipe() {
      this.loadingLista = true
      let response = await Functions.getCadastrosIndividuaisTodosPorEquipe(
        this.$store.state.cod_ibge,
        this.equipe.ine_esf_eap
      )
      if (response) {
        this.cadastrosOriginais = response
        this.cadastros = response
        this.filtros(this.nivelSelecionado)
        this.loadingLista = false
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.micro_area
      )
    },
  },
  created() {},
}
</script>

<style scoped lang="scss">
.select-situacao {
  margin: 10px;
  min-width: 210px;
}
@media (max-width: 768px) {
  button {
    margin-top: 0;
  }
}
@media screen and (max-width: 992px) {
  .info-table {
    flex-direction: column;
  }
}
</style>
<style>
#risco-cardiovascular .select-situacao .vs__dropdown-menu {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  padding: 0px;
}
#risco-cardiovascular .select-situacao .vs--searchable .vs__dropdown-toggle {
  padding: 5px;
}
#risco-cardiovascular .select-situacao .v-select {
  width: 296px;
}
#risco-cardiovascular .select-situacao .vs__dropdown-toggle {
  background-color: #fff;
}
</style>
<style>
.resultado-risco-cardiovascular {
  cursor: pointer;
  display: flex;
  padding: 10px 1rem;
  gap: 15px;
  font-size: 20px;
  color: black;
  background: white;
  justify-content: flex-end;
  padding-bottom: 5px;
}
.resultado-risco-cardiovascular .esus-feedback-tabs ul li .nav-link {
  padding-top: 0;
  padding-bottom: 0;
}
.resultado-risco-cardiovascular .esus-feedback-tabs ul li .nav-link.active {
  color: #0056b3 !important;
  border-color: unset !important;
  border-bottom: unset;
  border: unset;
}
.resultado-risco-cardiovascular .nav-tabs {
  border-bottom: unset;
}
</style>
